import { compareCachedCapabilities } from 'js/utils/capability-order';

function denormalizeCapability(capability, capabilityCache) {
  return {
    ...capability,
    children: Object.keys(capability.children)
      .map((childId) =>
        denormalizeCapability(capabilityCache[childId], capabilityCache)
      )
      .sort(compareCachedCapabilities),
  };
}

export function buildCapabilitySetsFromCache(
  capabilitySetCache,
  capabilityCache
) {
  return Object.fromEntries(
    Object.entries(capabilitySetCache).map(([id, cs]) => [
      id,
      {
        ...cs,
        capabilities: Object.keys(cs.capabilities)
          .map((cKey) =>
            denormalizeCapability(capabilityCache[cKey], capabilityCache)
          )
          .sort(compareCachedCapabilities),
      },
    ])
  );
}
